export default {
    errors: {
        min: 'Too few columns, there should be {cnt}',
        max: 'Too many columns, there should be {cnt}',
        includes: 'Wrong columns, allowed are: {examples}',
        collection: 'No user data found in Excel file'
    },
    lines: '{count} line found|{count} lines found',
    file: 'File selection',
    next: 'Next'
}
